<template>
  <FormulateInput :type="type" v-bind="$attrs" :key="Math.random()" :uploader="uploader" :value="value" @input="$emit('input', $event)" @change="$emit('change', $event)">
    <template #label="{ id }">
      <label :for="id">
        <slot name="label" />
      </label>
    </template>
    <template #uploadAreaMask>
      <slot name="uploadAreaMask" />
    </template>
  </FormulateInput>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'file',
    },
    value: {
      type: Object,
    },
    uploader: {
      type: Function,
    },
  },
};
</script>

<style lang="postcss" scoped>
label {
  @apply hover:cursor-pointer;
}
</style>
